export { default } from "./alarms.web";
